import {Loader} from '@rocket-ui/components';
import {useAtom, useAtomValue} from 'jotai';
import React, {FC, PropsWithChildren} from 'react';
import {tokenExpirationWatcherEffect} from '../model/authAtom';
import {axiosInterceptorAuthHeaderEffect, tokenIsSetAtom} from '../model/clientAuthAtom';

export const TokenManager: FC<PropsWithChildren> = ({children}) => {
	const isTokenSet = useAtomValue(tokenIsSetAtom);

	useAtom(tokenExpirationWatcherEffect);
	useAtom(axiosInterceptorAuthHeaderEffect);

	if (!isTokenSet) return <Loader.Default />;

	return <>{children}</>;
};
